import React from 'react';
import Layout from '../../components/Shared/Layout';
import Alexgo from '../../components/Portfolio/alexgo';
import '../../assets/css/bbqguru.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class AlexgoPage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/bbqguru',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <Alexgo />
      </Layout>
    );
  }
}

export default AlexgoPage;
